/* Kraken Bond - ust secenek degisince alt secenegin yanlis degere dusmesi duzeltmesi
 *
 * Sorun: Variant Image Wizard & Swatch (Rio) uygulamasi, ust secenek degisip
 * secili alt deger gecersiz kalinca yerine deger listesindeki EN YAKIN index'i
 * seciyor. FastCoat'ta Size listesi [8 adet "... Pack Kit"][11 adet "... Cans"]
 * seklinde iki ayrik blok oldugu icin, Can Only'den Foam Kit'e donuste sinirin
 * hemen altindaki deger, yani 192 Pack Kit secilmis oluyor.
 *
 * Kural: alt secenegin gecerli deger kumesi ust secenek degisince TAMAMEN
 * degistiyse (eski ve yeni kume kesismiyorsa) "en yakin" diye bir sey yoktur;
 * o zaman alt secenegi listedeki ILK gecerli degere cekiyoruz. Kumeler
 * kesisiyorsa (normal urunler) hicbir seye dokunmuyoruz.
 *
 * Iki katman:
 *  1) Tiklama aninda yakalayip uygulamayi tek adimda hedef varyanta kurar,
 *     boylece yanlis degerin bir an gorunmesi (titreme) hic olusmaz.
 *  2) Emniyet agi: 1. katman devreye giremezse tema select/radio'sunu duzeltir.
 */
(function () {
  // ---------- ortak yardimcilar ----------

  function controlsOf(picker) {
    return [].slice.call(picker.querySelectorAll('select, fieldset')).map(function (el) {
      if (el.tagName === 'SELECT') {
        return {
          el: el,
          get: function () { return el.value; },
          values: function () { return [].map.call(el.options, function (o) { return o.value; }); },
          set: function (v) { el.value = v; return el; }
        };
      }
      var radios = [].slice.call(el.querySelectorAll('input[type="radio"]'));
      return {
        el: el,
        get: function () {
          var c = radios.filter(function (r) { return r.checked; })[0];
          return c ? c.value : null;
        },
        values: function () { return radios.map(function (r) { return r.value; }); },
        set: function (v) {
          var hit = null;
          radios.forEach(function (r) { if (r.value === v) { r.checked = true; hit = r; } });
          return hit;
        }
      };
    });
  }

  function dataOf(picker) {
    var el = picker.querySelector('script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function anyMatch(data, opts, mustBeAvailable) {
    for (var i = 0; i < data.length; i++) {
      var v = data[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
      }
      if (ok && (!mustBeAvailable || v.available)) return true;
    }
    return false;
  }

  function validValues(data, prefix, control, mustBeAvailable) {
    return control.values().filter(function (val) {
      return anyMatch(data, prefix.concat([val]), mustBeAvailable);
    });
  }

  function disjoint(a, b) {
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) > -1) return false;
    return true;
  }

  // Eski ve yeni gecerli deger kumeleri ayrik mi? Oyleyse yeni kumenin ilk degeri.
  function replacementFor(data, control, oldPrefix, newPrefix) {
    var oldValid = validValues(data, oldPrefix, control, true);
    var newValid = validValues(data, newPrefix, control, true);
    if (!newValid.length) {
      // yeni secenekte stokta hicbir sey yok: en azindan gecerli bir eslesmeye dus
      oldValid = validValues(data, oldPrefix, control, false);
      newValid = validValues(data, newPrefix, control, false);
    }
    if (!newValid.length || !disjoint(oldValid, newValid)) return null;
    return newValid[0];
  }

  // ---------- 1. katman: tiklamayi yakala, tek adimda hedefe kur ----------

  function rioGroups() {
    var all = document.querySelectorAll('*'), root = null;
    for (var i = 0; i < all.length; i++) {
      if ((all[i].className || '').toString().indexOf('rio-options') > -1) { root = all[i]; break; }
    }
    if (!root || !root.firstElementChild) return [];
    return [].slice.call(root.firstElementChild.children).filter(function (c) {
      return c.querySelector('[class*=PwzrButtonBase-root]');
    });
  }

  window.addEventListener('click', function (e) {
    try {
      var api = window.__productWizRioOptions;
      if (!api || typeof api.forceUpdate !== 'function') return;

      var groups = rioGroups();
      if (groups.length !== 2 || !groups[0].contains(e.target)) return;

      var btns = [].slice.call(groups[0].querySelectorAll('[class*=PwzrButtonBase-root]'));
      var idx = -1;
      for (var k = 0; k < btns.length; k++) {
        if (btns[k] === e.target || btns[k].contains(e.target)) { idx = k; break; }
      }
      if (idx < 0) return;

      var picker = document.querySelector('block-variant-picker');
      if (!picker) return;
      var data = dataOf(picker);
      if (!data) return;
      var c = controlsOf(picker);
      if (c.length !== 2) return;

      // ekrandaki butonlar ile deger listesi birebir ortusmuyorsa hic dokunma
      var candidates = c[0].values().filter(function (v) { return anyMatch(data, [v], false); });
      if (candidates.length !== btns.length) return;

      var newV = candidates[idx], curV = c[0].get();
      if (!newV || newV === curV) return;

      var target = replacementFor(data, c[1], [curV], [newV]);
      if (target === null) return;

      var variant = data.filter(function (v) {
        return v.option1 === newV && v.option2 === target;
      })[0];
      if (!variant) return;

      // uygulamanin yanlis ara adimini hic calistirma
      e.stopPropagation();
      e.preventDefault();

      var node = c[0].set(newV) || c[0].el;
      c[1].set(target);
      node.dispatchEvent(new Event('change', { bubbles: true }));

      api.initialSelectedVariantId = String(variant.id);
      api.forceUpdate();

      // Uygulamanin "kac secenek degisti" defterini tazele: kendi akisindan ayni
      // degeri bir kez daha gecir. Aksi halde bir sonraki degisimde secenegin
      // sadece bir kismini temaya yaziyor.
      var prod = window.__productWizRioProduct;
      var name = prod && prod.options && prod.options[0] && prod.options[0].name;
      if (name) {
        setTimeout(function () {
          try {
            var cbs = window.__productWizRioOptions && window.__productWizRioOptions.cbs;
            if (cbs && typeof cbs[name] === 'function') cbs[name](newV);
          } catch (e2) {}
        }, 250);
      }
    } catch (err) { /* sessizce 2. katmana birak */ }
  }, true);

  // ---------- 2. katman: emniyet agi ----------

  var snap = {};

  function keyOf(picker) { return picker.getAttribute('data-product-id') || 'p'; }

  function snapshot() {
    [].slice.call(document.querySelectorAll('block-variant-picker')).forEach(function (picker) {
      var list = controlsOf(picker);
      if (list.length > 1) snap[keyOf(picker)] = list.map(function (c) { return c.get(); });
    });
  }

  ['mousedown', 'touchstart', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, snapshot, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', snapshot);
  else snapshot();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var picker = t.closest('block-variant-picker');
    if (!picker) return;

    var list = controlsOf(picker);
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].el === t || list[i].el.contains(t)) { idx = i; break; }
    }
    if (idx < 0 || idx >= list.length - 1) return;

    var key = keyOf(picker);
    var before = snap[key];
    var cur = list.map(function (c) { return c.get(); });
    if (!before || before.length !== cur.length) { snap[key] = cur; return; }
    if (before[idx] === cur[idx]) return;

    var data = dataOf(picker);
    if (!data) return;

    for (var j = idx + 1; j < list.length; j++) {
      var target = replacementFor(data, list[j], before.slice(0, j), cur.slice(0, j));
      if (target === null) break;
      if (list[j].get() !== target) { list[j].set(target); cur[j] = target; }
    }
    snap[key] = cur;
  }, true);
})();
